/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Pending_StudentInputs */

const en_us2_coaching_pending_student = /** @type {(inputs: Coaching_Pending_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has not accepted yet`)
};

const pt_br2_coaching_pending_student = /** @type {(inputs: Coaching_Pending_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não aceitou`)
};

const pt_pt2_coaching_pending_student = /** @type {(inputs: Coaching_Pending_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não aceitou`)
};

/** @type {(inputs: Coaching_Pending_StudentInputs) => LocalizedString} */
const es_419_coaching_pending_student = en_us2_coaching_pending_student;

/** @type {(inputs: Coaching_Pending_StudentInputs) => LocalizedString} */
const fr_fr2_coaching_pending_student = en_us2_coaching_pending_student;

/** @type {(inputs: Coaching_Pending_StudentInputs) => LocalizedString} */
const de_de2_coaching_pending_student = en_us2_coaching_pending_student;

/** @type {(inputs: Coaching_Pending_StudentInputs) => LocalizedString} */
const it_it2_coaching_pending_student = en_us2_coaching_pending_student;

/**
* | output |
* | --- |
* | "Has not accepted yet" |
*
* @param {Coaching_Pending_StudentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_pending_student = /** @type {((inputs?: Coaching_Pending_StudentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Pending_StudentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_pending_student(inputs)
	if (locale === "es-419") return es_419_coaching_pending_student(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_pending_student(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_pending_student(inputs)
	if (locale === "de-DE") return de_de2_coaching_pending_student(inputs)
	if (locale === "it-IT") return it_it2_coaching_pending_student(inputs)
	return en_us2_coaching_pending_student(inputs)
});
export { coaching_pending_student as "coaching.pending_student" }